import PropTypes from 'prop-types';
import {
  Box,
} from '@mui/material';
import { useStyles } from './style';

export const FormPageNavBtns = ({ formPageNumber = 1, activePgNum = 1, onDotClick }) => {
  const classes = useStyles();

  return (
    <Box className={classes.pageNavContainer}>
      {
        (formPageNumber > 0) && [...Array(formPageNumber)].map((_, i) => <Box component="button" key={i} onClick={() => onDotClick(i)} className={`${classes.pageNavCircleBtn} ${activePgNum === (i + 1) && classes.active}`} />)
      }
    </Box>
  );
};

FormPageNavBtns.propTypes = {
  formPageNumber: PropTypes.number,
  activePgNum: PropTypes.number,
  onDotClick: PropTypes.func
};

FormPageNavBtns.defaultProps = {
  formPageNumber: 1,
  activePgNum: 1,
  onDotClick: () => { }
};
